import InfoTooltip from "./InfoTooltip";

export const TabsList = [
  {
    id: "overall-performance",
    label: <div style={{
      display: 'flex',
      gap: '8px',
      alignItems: 'center'
    }}><span>Overall Performance</span> <InfoTooltip placement="bottom" id="trouble-spots-info">
        <div style={{ textAlign: "left" }}>
          Shows your overall performance across Practice Sets, Test Sets, and Full-Length Exams.
        </div>
      </InfoTooltip></div>,
  },
  {
    id: "classes-attended",
    label: <div style={{
      display: 'flex',
      gap: '8px',
      alignItems: 'center'
    }}><span>Classes Attended</span> <InfoTooltip placement="bottom" id="trouble-spots-info">
        <div style={{ textAlign: "left" }}>
          Shows details of all your attended and missed classes.
        </div>
      </InfoTooltip></div>,
  },
  {
    id: "trouble-spots",
    label: <div style={{
      display: 'flex',
      gap: '8px',
      alignItems: 'center'
    }}><span>Trouble Spots</span> <InfoTooltip placement="bottom" id="trouble-spots-info">
        <div style={{ textAlign: "left" }}>
          <strong>What shows up here?</strong>
          <ul style={{ paddingLeft: "1rem", margin: "0.4rem 0 0" }}>
            <li>Practice sets or tests where you scored below 50%</li>
            <li>Speaking or Writing attempts with a band score of 5 or lower</li>
            <li>Only your most relevant attempts — cleared items mean you're improving</li>
          </ul>
        </div>
      </InfoTooltip></div>,
  },
  {
    id: "scores",
    label: <div style={{
      display: 'flex',
      gap: '8px',
      alignItems: 'center'
    }}><span>Scores</span> <InfoTooltip placement="bottom" id="trouble-spots-info">
        <div style={{ textAlign: "left" }}>
          Select a subject to view your performance by topic. It shows all the topics you have attempted, along with your score for each topic.
        </div>
      </InfoTooltip></div>,
  },
  {
    id: "diagnostic",
    label: <div style={{
      display: 'flex',
      gap: '8px',
      alignItems: 'center'
    }}><span>Diagnostic</span> <InfoTooltip placement="bottom" id="trouble-spots-info">
        <div style={{ textAlign: "left" }}>
          Shows topics that are closest to Champion Level and highlights the topics that require the least improvement to reach Champion Level.
          <ul style={{ paddingLeft: "1rem", margin: "0.4rem 0 0" }}>
            <li>Topics Near Champion Level: Prioritizes topics where you are closest to achieving Champion Level.</li>
            <li>Champion Level: Topics with a score of 90% or above are considered Champion Level. This includes your performance across all Practice Sets and Test Sets for that topic.</li>
          </ul>
        </div>
      </InfoTooltip></div>,
  },
];

export const BasicInformationButtons = [
  {
    styles: { marginRight: "12px" },
    label: "Save",
    onClick: () => {},
    varient: "outline",
  },
  {
    styles: { paddingLeft: "24px", paddingRight: "24px" },
    label: "Save & Preview",
    onClick: () => {},
    varient: "link",
  },
];

export const AddLiveClassesButtons = [
  {
    styles: { marginRight: "12px" },
    label: "Create Single Live Class",
    onClick: () => {},
    varient: "outline",
  },
  {
    styles: { paddingLeft: "24px", marginRight: "12px" },
    label: "Create Bulk Live Classes",
    onClick: () => {},
    varient: "outline",
  },
];

export const PricingButtons = [
  {
    styles: { marginRight: "12px" },
    label: "Import",
    onClick: () => {},
    varient: "outline",
  },
  {
    styles: { paddingLeft: "24px", paddingRight: "24px" },
    label: "Create New",
    onClick: () => {},
    varient: "outline",
  },
];

export const DownloadButtons = [
  {
    styles: { marginRight: "12px" },
    label: "Download",
    onClick: () => {},
    varient: "outline",
  },
];

export const activeTabsList = [
  {
    id: "practice-performance",
    label: "Practice Performance",
  },
  {
    id: "test-performance",
    label: "Test Performance",
  },
  {
    id: "full-length-exams",
    label: "Full Length Performance",
  },
];
